

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import popimg from "../../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from "../../Common/Images/ImagesForAlert/popup_bg2.png";
import popclose from "../../Common/Images/ImagesForAlert/popup_close_n.png";
import Loading from "../../Common/Loading"

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;



const css = `
  * { box-sizing: border-box; }
html, body {
  margin: 0;
  padding: 0;
  font-family: 'Trebuchet MS', Tahoma, sans-serif;
  font-size: 10pt;
  font-weight: bold;
  background: azure;
  overflow: hidden;
  width: 100%;
  min-width: 320px;
  max-width: 100vw;
  height: 100%;
}

  /* Outer wrapper — mirrors <div style="padding:2px;margin:0px;"> */
.outer-wrapper {
  padding: 2px;
  margin: 0;
  height: calc(100vh - 35px);
  min-height: 0;
  max-height: calc(100vh - 35px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

  /* Title bar — mirrors cssContentTitle +
     objGrid.Title popup chrome (blue bar with white text + red X)
     Exact match to screenshot: blue background, white bold text, red X on right */
  .title-bar {
    background-color: #c7ddfd;
    color: #fff;
    font-family: 'Trebuchet MS', sans-serif;
    font-size: 10pt;
    font-weight: bold;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 6px 0 10px;
    user-select: none;
    flex-shrink: 0;
  }

  .title-bar-text {
    font-size: 10pt;
    font-weight: bold;
  }

  /* Red X close button — mirrors the popup chrome close button in screenshot */
  .title-bar-close {
    background-color: #c0392b;
    border: none;
    color: #fff;
    font-size: 11px;
    font-weight: bold;
    width: 20px;
    height: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    padding: 0;
    flex-shrink: 0;
  }

  .title-bar-close:hover {
    background-color: #e74c3c;
  }

  /* Main content area with the table */
  .content-area {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border: 1px solid #A0A0A0;
    border-top: none;
    background: #fff;
  }

  /* "Select Curriculum(s) for SCHOOLCODE" heading row
     Mirrors: objGrid.Title — light blue background, centred text */
  .grid-title {
    background-color: #c7ddfd;
    border-bottom: 1px solid #80a0ff;
    padding: 8px 5px;
    text-align: center;
    font-family: 'Trebuchet MS', sans-serif;
    font-size: 10pt;
    font-weight: normal;
    color: #000;
    flex-shrink: 0;
  }

  .grid-title b {
    font-size: 12pt;
    font-weight: bold;
  }

  /* Scrollable table wrapper — mirrors lst_divScrollableTable */
  .scroll-table-wrapper {
    flex: 1;
    min-height: 0;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  /* Table — mirrors clsGrid.ConstructScrollableTable output
     width:100%, border:solid 1px #A0A0A0, cssGridView */
  .curriculum-table {
    width: 100%;
    border-collapse: collapse;
    font-family: 'Trebuchet MS', sans-serif;
    font-size: 8pt;
    color: black;
    border-style: none;
    table-layout: fixed;
  }

  .curriculum-table thead {
    position: sticky;
    top: 0;
    z-index: 1;
  }


  .curriculum-table thead tr {
    background-color: #c7ddfd;
    color: #fff;
    font-weight: normal;
    font-size: 15pt;
  }

  .curriculum-table thead th {
    padding: 5px 5px 5px 5px;
    font-weight: normal;
    font-family: 'Trebuchet MS', sans-serif;
    font-size: 8pt;
    text-align: left;
    border: none;
  }

  /* Checkbox column header — 40px, centred */
  .curriculum-table thead th.col-check {
    width: 40px;
    text-align: center;
  }

  /* Data rows — mirrors cssGridRow (white) and cssGridAltRow (#EFF3FB) */
  .curriculum-table tbody tr.row-normal {
    background-color: #f4faff;
    border-bottom: 1px solid #80a0ff;
  }

  .curriculum-table tbody tr.row-alt {
    background-color: #fff;
    border-bottom: 1px solid #80a0ff;
  }

  /* Hover on data rows */
  .curriculum-table tbody tr:hover {

    cursor: pointer;
  }

  /* Selected row style (mirrors lst_fn_SelectRow 'C' — checked rows) */
.curriculum-table tbody tr.row-selected {
  background-color: inherit;
}
  .curriculum-table tbody td {
    padding: 5px 5px 5px 5px;
    border-bottom: 1px solid #e0e8f4;
    font-family: 'Trebuchet MS', sans-serif;
    font-size: 8pt;
    color: #000;
  }

  .curriculum-table tbody td.col-check {
    width: 40px;
    text-align: center;
    vertical-align: middle;
  }

  /* Checkbox styling — matches screenshot checkboxes */
  .curriculum-table input[type="checkbox"] {
    width: 13px;
    height: 13px;
    cursor: pointer;
    vertical-align: middle;
  }

  /* Bottom buttons row — mirrors <div id="divbuttons" align="center" style="padding-top:8px;"> */
  .btn-row {
    text-align: center;
    padding: 8px 0 8px 0;
    flex-shrink: 0;
    background: #fff;
    border-top: 1px solid #80a0ff;
  }

  /* OK / Cancel buttons — mirrors inline style: width:75px; cursor:pointer
     Look matches screenshot grey buttons */
  .btn-ok,
  .btn-cancel {
    width: 75px;
    height: 23px;
    cursor: pointer;
    font-family: 'Trebuchet MS', sans-serif;
    font-size: 8pt;
    font-weight: normal;
    border: 1px solid #888;
    background-color: #e8e8e8;
    color: #000;
    margin: 0 4px;
  }

  .btn-ok:hover,
  .btn-cancel:hover {
    background-color: #d0d8e8;
    border-color: #80a0ff;
  }

  .btn-ok:active,
  .btn-cancel:active {
    background-color: #b8c8dc;
  }

  /* Loading / error states */
  .status-msg {
    padding: 20px;
    text-align: center;
    font-family: 'Trebuchet MS', sans-serif;
    font-size: 9pt;
    color: #555;
  }

  /* Validation error — mirrors gfn_ShowMessage "Please select a Curriculum." */
  .validation-msg {
    color: red;
    font-size: 8pt;
    padding: 2px 8px 0 8px;
    text-align: center;
    min-height: 16px;
    font-family: 'Trebuchet MS', sans-serif;
  }
`;


export default function ELSelectCurriculum() {

  // ── Read QueryString — mirrors Request.QueryString("SchoolCode") / ("Curriculum") ──
  const qp = new URLSearchParams(window.location.search);
  const schoolCode = qp.get("SchoolCode") ?? "";
  const initialCurriculum = qp.get("Curriculum") ?? "";  // comma-separated pre-selected

  // ── State ──────────────────────────────────────────────────────────────────
  const [curricula, setCurricula] = useState<string[]>([]);
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const [loading, setLoading] = useState(true);
  const [validMsg, setValidMsg] = useState("");
  const allSelected =
    curricula.length > 0 &&
    curricula.every(curriculum => selected.has(curriculum));



  const navigate = useNavigate();
  const toggleAll = () => {
    setValidMsg("");

    if (allSelected) {
      setSelected(new Set());
    } else {
      setSelected(new Set(curricula));
    }
  };
  useEffect(() => {
    document.body.style.backgroundColor = "azure";
  })

  // ── Fetch data on mount — mirrors Page_Load + LoadCurriculum() ────────────
  useEffect(() => {
    const params = new URLSearchParams({ SchoolCode: schoolCode, Curriculum: initialCurriculum });
    fetch(`${API_BASE_URL}api/webadmin/curriculum/?${params.toString()}`)
      .then(r => r.json())
      .then((d: { curricula: string[]; curriculum: string }) => {
        setCurricula(d.curricula ?? []);

        // mirrors: fn_SelectCurriculum() — pre-check rows matching Curriculum QS
        // "if ('<%=Curriculum%>' == '') return; var currArr = '<%=Curriculum%>'.split(",")"
        const preSelected = new Set<string>();
        if (d.curriculum) {
          d.curriculum.split(",").forEach(c => {
            const trimmed = c.trim();
            if (trimmed) preSelected.add(trimmed);
          });
        }
        setSelected(preSelected);
      })
      .catch(() => setCurricula([]))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function toggleRow(name: string) {
    setValidMsg("");
    setSelected(prev => {
      const next = new Set(prev);
      if (next.has(name)) next.delete(name);
      else next.add(name);
      return next;
    });
  }

  function fn_GetCurriculum() {
    const value = Array.from(selected).join(",").trim();
    if (!value) {
      // mirrors: gfn_ShowMessage("Please select a Curriculum.", 'A', '', null, 'S')
      setValidMsg("Please select a Curriculum.");
      return;
    }

    if (window.opener) {
      window.opener.postMessage({ curriculum: value }, "*");
    }
    window.close();
  }


  function fn_close() {
    if (window.opener) {
      window.opener.postMessage({ curriculum: "" }, "*");
    }
    window.close();
  }

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <>
      <style>{css}</style>

      <div
        style={{
          backgroundImage: `url(${popimg}), url(${popbg})`,
          backgroundRepeat: "no-repeat, no-repeat",
          backgroundPosition: "left center, right center",
          backgroundSize: "30% 100%, 70% 100%",
          height: "35px",
          color: "white",
          padding: "7px 0px",
          fontWeight: "bold",
          fontSize: "12pt",
          fontFamily: "arial",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",

        }}
      >
        <span style={{ marginLeft: "10px" }}>
          Curriculums
        </span>
        <img
          src={popclose}
          alt="close"
          height="30px"
          style={{ cursor: "pointer" }}
          onClick={() => window.close()}
        />
      </div>
      <div className="outer-wrapper">



        {/* Main content area */}
        <div className="content-area">


          <div className="grid-title" id="gridTitle" style={{ color: "#2859ac" }}>
            Select Curriculum(s) for <b>{schoolCode}</b>
          </div>

          {/* Scrollable table wrapper — mirrors lst_divScrollableTable */}
          <div className="scroll-table-wrapper" id="lst_divScrollableTable">
            {loading ? (
              <div className="status-msg">
                <Loading />
              </div>
            ) : (

              <table className="curriculum-table">
                <thead>
                  <tr>
                    <th
                      className="col-check"
                      style={{
                        borderLeft: "1px solid #a3c0e8",
                        textAlign: "center"
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={allSelected}
                        onChange={toggleAll}
                        title="Select All"
                      />
                    </th>

                    <th
                      style={{
                        borderLeft: "1px solid #a3c0e8",
                        color: "#2859ac",
                        padding: "10px",
                        fontSize: "12pt"
                      }}
                    >
                      Curriculum
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {curricula.map((name, idx) => {
                    const isChecked = selected.has(name);
                    // mirrors: cssGridRow (even) / cssGridAltRow (odd) + row-selected when checked
                    const rowClass =
                      idx % 2 === 0
                        ? "row-normal"
                        : "row-alt";
                    return (
                      <tr
                        key={name}
                        className={rowClass}
                        onClick={() => toggleRow(name)}
                      >
                        {/* Checkbox cell — mirrors lst_fn_SelectRow 'C' CHECKBOXES */}
                        <td className="col-check" style={{ borderBottom: '1px solid #a3c0e8', borderLeft: '1px solid #a3c0e8', padding: '10px', fontSize: '10pt' }} onClick={e => e.stopPropagation()}>
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => toggleRow(name)}
                          />
                        </td>
                        {/* Curriculum name — mirrors <%# Eval("Major") %> / column text */}
                        <td style={{ borderBottom: '1px solid #a3c0e8', borderLeft: '1px solid #a3c0e8', padding: '10px', fontSize: '10pt' }}>{name}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>

          {/* Validation message — mirrors gfn_ShowMessage("Please select a Curriculum.", 'A') */}
          <div className="validation-msg">{validMsg}</div>

          {/* Button row — mirrors <div id="divbuttons" align="center" style="padding-top:8px;"> */}
          <div className="btn-row" id="divbuttons">
            {/* OK button — mirrors <input id="btnOk" value="OK" onclick='fn_GetCurriculum();' type="button" style="width:75px;cursor:pointer;"/> */}
            <button
              id="btnOk"
              className="btn-ok"
              onClick={fn_GetCurriculum}
            >
              OK
            </button>
            &nbsp;&nbsp;
            {/* Cancel button — mirrors <input id="btnCancel" value="Cancel" type="button" onclick='Javascript: fn_close();' style="width:75px;cursor:pointer;"/> */}
            <button
              // id="btnCancel"
              // className="btn-cancel"
              onClick={fn_close}
              style={{ backgroundColor: "#e8e8e8", color: "black", padding: "3px 20px", border: "1px solid grey" }}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>
    </>
  );
}